import React from "react";
import "../css/Mensaje.css"
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";


export default function Mensaje(props) {

    return (
        <Dialog open={props.open} fullWidth>

            <DialogTitle>Información</DialogTitle>
            <DialogContent>
                <div className="Mens-texto">
                    {props.texto}
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => { props.cerrar() }}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}